// DEPRECATED: 1 || 0 flags
export var ACCOUNT_DELETION = 'account_deletion';
export var ODR_GAMES = 'odr_games';
export var SNEAK_PEEK = 'sneak_peek'; // JSON flags

export var FE_ACCOUNT_DELETION = 'fe_account_deletion';
export var FE_ODR_GAMES = 'fe_odr_games';
export var FE_SNEAK_PEEK = 'fe_sneak_peek';
export var FE_JSONSCHEMA_VALIDATION = 'fe_jsonschema_validation';
export var FE_MISSIONS = 'fe_missions';
export var FE_MISSYOU_NOTIFICATION = 'fe_missyou_notification';
export var FE_PROGRESSIVE_JACKPOTS = 'fe_progressive_jackpots';
export var FE_LINK_GUEST_LOGIN = 'fe_link_guest_login';
export var FE_ANIMATION = 'fe_animation';
/**
 * This object is the array to be used to validate with our provider.
 */

export var FLAG_VALUES = [FE_ACCOUNT_DELETION, FE_ODR_GAMES, FE_SNEAK_PEEK, FE_JSONSCHEMA_VALIDATION, FE_MISSYOU_NOTIFICATION, FE_PROGRESSIVE_JACKPOTS, FE_MISSIONS, FE_LINK_GUEST_LOGIN, FE_ANIMATION];
/**
 * This object is the default array to use in case of an error.
 */

export var FLAG_DEFAULT_VALUES = {
  fe_account_deletion: {
    enabled: true
  },
  fe_jsonschema_validation: {
    '/v2/getTermsAndConditionsUrl': {
      GET: {
        enabled: true,
        skip_errors: false
      }
    },
    '/v2/getFbAppId': {
      GET: {
        enabled: true,
        skip_errors: false
      }
    },
    '/missions/player': {
      GET: {
        enabled: true,
        skip_errors: false
      },
      POST: {
        enabled: true,
        skip_errors: false
      }
    },
    '/assets': {
      GET: {
        enabled: true,
        skip_errors: false
      }
    },
    '/games/progressiveJackpots': {
      GET: {
        enabled: true,
        skip_errors: false
      }
    },
    '/v2/getDailyWheelBonusData': {
      GET: {
        enabled: true,
        skip_errors: false
      }
    },
    '/v2/guestlinkemail': {
      POST: {
        enabled: true,
        skip_errors: false
      }
    },
    '/v2/guestLinkGoogleAccount': {
      POST: {
        enabled: true,
        skip_errors: false
      }
    },
    '/v2/guestLinkAppleAccount': {
      POST: {
        enabled: true,
        skip_errors: false
      }
    },
    '/v2/guestLinkFacebookAccount': {
      POST: {
        enabled: true,
        skip_errors: false
      }
    }
  },
  fe_missyou_notification: {
    enabled: false,
    title: '💕We miss you!',
    body: 'SPIN 🎰 back in and PLAY your favorite game!',
    inactivityHours: 72
  },
  fe_missions: {
    enabled: false
  }
};